/* eslint-disable react/no-array-index-key */
import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import propTypes from 'prop-types';
import { FaPlusCircle } from 'react-icons/fa';
import Input from '../../../components/Input';
import './styles.scss';

export default function SubjectOptions({ subject, index }) {
  const { handleChange, errors } = useFormikContext();

  return (
    <FieldArray
      name={`subjects[${index}].options`}
      render={({ push, remove }) => (
        <>
          {subject.options.map((option, idx) => (
            <div className="input-group mb-3" key={idx}>
              <Input
                type="text"
                placeholder={`Opção ${idx + 1}`}
                name={`subjects[${index}].options[${idx}].description`}
                value={option.description}
                onChange={handleChange}
              />
              <div className="input-group-append">
                <button
                  className="input-group-text btn-clear"
                  type="button"
                  onClick={() => subject.options.length > 1 && remove(idx)}
                >
                  X
                </button>
              </div>
            </div>
          ))}

          {errors && errors.subjects && errors.subjects && errors.subjects[index] && errors.subjects[index].options && (
            <>
              <small className="text-danger mb-4">Favor preencher a opção.</small>
            </>
          )}

          <button
            className="btn-add-subject-option d-flex align-items-center"
            type="button"
            onClick={() => push({ description: '' })}
          >
            <FaPlusCircle className="mr-2" />
            adicionar opção de voto
          </button>
        </>
      )}
    />
  );
}

SubjectOptions.propTypes = {
  subject: propTypes.object.isRequired,
  index: propTypes.number.isRequired,
};
